"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const StyledRecoilUsedHeader_1 = require("./styled/StyledRecoilUsedHeader");
const RecoilUsedInput_1 = __importDefault(require("./RecoilUsedInput"));
const recentSearchList_1 = require("../../modules/recentSearchList");
const useContextAPI_1 = require("../../hooks/useContextAPI");
const useWindowSize_1 = __importDefault(require("../../hooks/useWindowSize"));
const CommonDeskHeaderProvider_1 = require("../CommonDeskHeaderProvider");
const imageUrl_1 = require("../../resource/imageUrl");
const modalHandler_1 = require("../../handler/autoComplete/desktop/Common/modalHandler");
const urlHandler_1 = require("../../modules/urlHandler");
const RecoilUsedHeader = ({ full_width, input_width, user, setPopup, }) => {
    (0, recentSearchList_1.replaceRecent)();
    return ((0, jsx_runtime_1.jsxs)(RecoilUsedHeader.Wrap, { full_width: full_width, input_width: input_width, children: [(0, jsx_runtime_1.jsx)(RecoilUsedHeader.Logo, {}), (0, jsx_runtime_1.jsx)(RecoilUsedHeader.Input, { input_width: input_width, setPopup: setPopup, user: user }), (0, jsx_runtime_1.jsx)(RecoilUsedHeader.Auth, { user: user, children: (0, jsx_runtime_1.jsx)(RecoilUsedHeader.Personal, {}) })] }));
};
const initValue = (0, urlHandler_1.getQueryParams)().query;
const WrapCtx = react_1.default.memo(({ children, full_width, input_width }) => {
    const { focus, inputValue } = (0, useContextAPI_1.useValueContext)(CommonDeskHeaderProvider_1.CommonDeskHeaderValueCtx);
    const { setFocus, setInputValue, setAutoValue } = (0, useContextAPI_1.useSetContext)(CommonDeskHeaderProvider_1.CommonDeskHeaderDispatcherCtx);
    const { isPointed } = (0, useWindowSize_1.default)(1347);
    const onHeaderClick = (e) => {
        if (e.target.id === "DeleteImg") {
            if (focus) {
                setFocus(true);
                return;
            }
            else {
                setFocus(!focus);
                return;
            }
        }
        if (e.currentTarget === e.target) {
            setFocus(false);
            (0, modalHandler_1.onEscapeAction)({
                initValue,
                inputValue,
                setAutoValue,
                setFocus,
                setInputValue,
            });
            return;
        }
        if (e.target.classList && e.target.classList.length > 0) {
            e.target.classList.forEach((className) => {
                if (className.includes("Auth")) {
                    setFocus(false);
                    (0, modalHandler_1.onEscapeAction)({
                        initValue,
                        inputValue,
                        setAutoValue,
                        setFocus,
                        setInputValue,
                    });
                    return;
                }
                if (className.includes("User")) {
                    setFocus(false);
                    (0, modalHandler_1.onEscapeAction)({
                        initValue,
                        inputValue,
                        setAutoValue,
                        setFocus,
                        setInputValue,
                    });
                    return;
                }
                if (className.includes("Header__Wrap")) {
                    setFocus(false);
                    (0, modalHandler_1.onEscapeAction)({
                        initValue,
                        inputValue,
                        setAutoValue,
                        setFocus,
                        setInputValue,
                    });
                    return;
                }
            });
        }
    };
    (0, react_1.useEffect)(() => {
        if (focus) {
            document.body.style.overflow = "hidden";
            const $root = document.body.querySelector("#root");
            if (!$root)
                return;
            $root.style.overflow = "hidden";
            const $Sticky__Filter = document.body.querySelector(".Sticky__Filter");
            if (!$Sticky__Filter)
                return;
            $Sticky__Filter.style.zIndex = "100";
        }
        if (!focus) {
            document.body.style.removeProperty("overflow");
            const $root = document.body.querySelector("#root");
            if (!$root)
                return;
            $root.style.removeProperty("overflow");
            const $Sticky__Filter = document.body.querySelector(".Sticky__Filter");
            if (!$Sticky__Filter)
                return;
            $Sticky__Filter.style.zIndex = "300";
        }
    }, [focus]);
    return ((0, jsx_runtime_1.jsx)(Wrap, { full_width: full_width, input_width: input_width, isPointed: isPointed, onHeaderClick: onHeaderClick, children: children }));
});
const Wrap = react_1.default.memo(({ children, full_width, input_width, isPointed, onHeaderClick, }) => {
    return ((0, jsx_runtime_1.jsx)(StyledRecoilUsedHeader_1.RecoilUsedHeaderDiv, { className: "Common__Desk__Header", onMouseDown: onHeaderClick, children: (0, jsx_runtime_1.jsx)(StyledRecoilUsedHeader_1.HeaderWrapperDiv, { className: "Header__Wrap", full_width: full_width, input_width: input_width, isPointed: isPointed, children: children }) }));
});
const Logo = react_1.default.memo(() => {
    return ((0, jsx_runtime_1.jsx)(StyledRecoilUsedHeader_1.LogoDiv, { className: "Main__Logo", children: (0, jsx_runtime_1.jsx)("a", { href: "/", children: (0, jsx_runtime_1.jsx)("img", { className: "Diningcode__Logo", src: imageUrl_1.header_logo_img, alt: "\uB2E4\uC774\uB2DD\uCF54\uB4DC \uBA54\uC778\uB85C\uACE0" }) }) }));
});
// Input 컴포넌트
const Input = react_1.default.memo(({ input_width, user, setPopup, }) => {
    return ((0, jsx_runtime_1.jsx)(StyledRecoilUsedHeader_1.HeaderInputWrapDiv, { children: (0, jsx_runtime_1.jsx)(RecoilUsedInput_1.default, { input_width: input_width, setPopup: setPopup, user: user }) }));
});
// Auth 컴포넌트
const AuthCtx = react_1.default.memo(({ children, user }) => {
    const { setOpen } = (0, useContextAPI_1.useSetContext)(CommonDeskHeaderProvider_1.CommonDeskHeaderDispatcherCtx);
    return ((0, jsx_runtime_1.jsx)(Auth, { setOpen: setOpen, user: user, children: children }));
});
const Auth = react_1.default.memo(({ setOpen, children, user }) => {
    if (user.loggedUser && user.loggedUser.name) {
        return ((0, jsx_runtime_1.jsx)(StyledRecoilUsedHeader_1.AuthUserDiv, { className: "Auth__User__Div", children: (0, jsx_runtime_1.jsxs)("button", { className: "Auth__User__Button", onClick: () => {
                    setOpen((open) => !open);
                }, children: [(0, jsx_runtime_1.jsxs)("span", { className: "Authed__User", children: [(0, jsx_runtime_1.jsx)("span", { className: "User__Name", children: user.loggedUser.name.length > 12
                                    ? user.loggedUser.name.slice(0, 12) + "..."
                                    : user.loggedUser.name }), "\uB2D8"] }), (0, jsx_runtime_1.jsx)("img", { className: "Auth__User__Button__img", src: imageUrl_1.header_arrow_img, alt: "\uC720\uC800 \uC815\uBCF4 \uBAA8\uB2EC\uBA54\uB274 \uBC84\uD2BC \uC774\uBBF8\uC9C0" }), children] }) }));
    }
    if (user.loggedUser && !user.loggedUser.name) {
        return ((0, jsx_runtime_1.jsx)(StyledRecoilUsedHeader_1.AuthBoxDiv, { className: "Auth__Box" }));
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
});
//
// Personal 컴포넌트
const PersonalCtx = () => {
    const { open } = (0, useContextAPI_1.useValueContext)(CommonDeskHeaderProvider_1.CommonDeskHeaderValueCtx);
    return (0, jsx_runtime_1.jsx)(Personal, { open: open });
};
const Personal = react_1.default.memo(({ open }) => {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: open && ((0, jsx_runtime_1.jsxs)(StyledRecoilUsedHeader_1.PersonalModalDiv, { className: "Auth__modal", children: [(0, jsx_runtime_1.jsx)("a", { className: "User__Info", href: "/user/?mode=info", children: "\uB098\uC758 \uC815\uBCF4" }), (0, jsx_runtime_1.jsx)("a", { className: "User__Logout", href: "/user/?mode=logout", children: "\uB85C\uADF8\uC544\uC6C3" })] })) }));
});
RecoilUsedHeader.Wrap = WrapCtx;
RecoilUsedHeader.Logo = Logo;
RecoilUsedHeader.Input = Input;
RecoilUsedHeader.Auth = AuthCtx;
RecoilUsedHeader.Personal = PersonalCtx;
exports.default = RecoilUsedHeader;
